function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#0074C2",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M23.2 11.2c-.442 0-.8-.358-.8-.8-.006-4.858-3.942-8.794-8.8-8.8-.442 0-.8-.358-.8-.8 0-.442.358-.8.8-.8C19.34.007 23.993 4.66 24 10.4c0 .442-.358.8-.8.8z",
  transform: "translate(-1373 -1052) translate(1225 1047) translate(148 5)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.4 11.2c-.442 0-.8-.358-.8-.8-.003-2.208-1.792-3.997-4-4-.442 0-.8-.358-.8-.8 0-.442.358-.8.8-.8 3.091.004 5.596 2.509 5.6 5.6 0 .442-.358.8-.8.8zM16.022 14.823l-1.956 2.445c-3.029-1.78-5.554-4.305-7.334-7.334l2.445-1.956c.59-.472.786-1.282.48-1.971L7.43.988c-.33-.744-1.15-1.14-1.937-.934l-4.24 1.1C.432 1.368-.1 2.16.016 3 1.546 13.893 10.107 22.454 21 23.984c.839.116 1.631-.414 1.845-1.233l1.1-4.24c.204-.787-.19-1.606-.933-1.936l-5.019-2.23c-.689-.307-1.499-.111-1.97.478z",
  transform: "translate(-1373 -1052) translate(1225 1047) translate(148 5)"
}))))));

var SvgPhoneBlue = function SvgPhoneBlue(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhoneBlue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phone-blue.547104dd.svg";
export { ForwardRef as ReactComponent };